export default {
  url: '',
  lists: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/urllookup/state.js